import AppDispatcher from '../dispatcher/AppDispatcher';
import BaseConstants from '../constants/BaseConstants';
import {EventEmitter} from 'events';
import LoginAPI from "../utils/LoginAPI";
import {createHistory} from "../history";
import decode from 'jwt-decode';
import cookies from 'browser-cookies';

const CHANGE_EVENT = 'CHANGE';

let _user = null;
let _jwt = '';
let _errorMessage = '';
let _session= false;
class LoginStore extends EventEmitter {
    constructor() {
        super();
        AppDispatcher.register(this._registerToActions.bind(this));

    }

    _registerToActions(payload) {
        try{
            const action = payload.action;
            switch (action.type) {
                case BaseConstants.LOGIN:
                    this.login(action.user);
                    break;
                default:
                    return '';
            }
            return true;
        }catch(e){
            console.log('_registerToActions function in LoginStore ',e)
        }
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    getUser() {
        return _user;
    }

    setUser() {
        try{
            //const user = decode(localStorage.getItem('jwt'));
            const user2 = decode(cookies.get('jwt'));
            //_user = user.iss + " " + user.sub;
            _user = user2.iss + " " + user2.sub;
        }catch(e){
            console.log('setUser function in LoginStore ',e)
        }
    }

    setJwt() {
        try{
            //_jwt = localStorage.getItem('jwt');
            _jwt = cookies.get('jwt');
        }catch(e){
            console.log('setUser function in LoginStore ',e)
        }
    }

    getJwt() {
        //_jwt = localStorage.getItem('jwt');
        _jwt = cookies.get('jwt');
        return _jwt;
    }

    getUserID() {
        const decodedJwt = decode(_jwt);
        return decodedJwt.jti;
    }

    isTokenExpired(token) {
        try {
            const decoded = decode(token);
            return (decoded.exp < Date.now() / 1000);
        }
        catch (err) {
            return false;
        }
    }

    isLoggedIn() {
        //return !!_user;
        return !!_jwt && !this.isTokenExpired(_jwt);
    }


    getSession(){
        return _session;
    }

    logout() {
        try{
            //localStorage.removeItem('jwt');
            cookies.erase('jwt');
            createHistory.push('/wlmgLogin');
        }catch(e){
            console.log('login function in LoginStore ',e)
        }
    }

    errorMessage() {
        return _errorMessage;
    }

    login(user) {
        LoginAPI.login(user).then(response => {
            switch (response.message) {
                case 'Failed to fetch':
                    _errorMessage = "Server has stopped please try later...!";
                    this.errorMessage();
                    this.emitChange();
                    break;
                default:
                    return response.json();
            }
        }).then(response => {
            _errorMessage= '';
            if(response !== undefined){
                if (response.user === "Not Found") {
                    _errorMessage = "Invalidate username or password please try again...!";
                    this.errorMessage();
                    this.emitChange();
                }else if (response.user === "Not Permitted") {
                    _errorMessage = "You don't have access to this application...!";
                    this.errorMessage();
                    this.emitChange();
                } else {
                    _jwt = response.jwt;
                    _session = true;
                    cookies.set('jwt',_jwt,{expires: 1});
                    //localStorage.setItem('jwt', _jwt);
                    createHistory.push('/wlmgHome');
                    this.emitChange();
                }
            }
        }).catch(e=>{console.log('login function in LoginStore ',e)});
    }


}

export default new LoginStore();


